import React, { useEffect, useRef, useState } from "react";
import "./Worksheet.css";
import WorksheetTable from "./WorksheetTable";
import HomeService from "../../../Services/HomeService";
import { tableData } from "./TableData";
import toast from "react-hot-toast";
import { useSelector } from "react-redux";
import HttpClientXml from "../../../utils/HttpClientXml";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const Worksheet = () => {
  const childRef = useRef();

  const userRole = localStorage.getItem("role");
  const userCity = localStorage.getItem("city");
  const loggedUserID = localStorage.getItem("uid");
  const [cities, setCities] = useState([]);
  const [selectedCity, setSelectedCity] = useState(userCity || "");
  const [propertyTypes, setPropertyTypes] = useState([]);
  const [selectedPropertyType, setSelectedPropertyType] = useState("");
  const [totalFilteredProperty, setTotalFilteredProperty] = useState("");

  const [localities, setLocalities] = useState([]);
  const [selectedLocality, setSelectedLocality] = useState("");

  const [allApartments, setAllApartments] = useState([]);
  const [apartments, setApartments] = useState([]);
  const [selectedApartment, setSelectedApartment] = useState("");
  const [apartmentOptions, setApartmentOptions] = useState([]);

  const [selectedAddress, setSelectedAddress] = useState("");

  const [properties, setProperties] = useState([]);

  const [propertiesForFutureUse, setPropertiesForFutureUse] = useState([]);

  const [loading, setLoading] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(100);
  const [totalPages, setTotalPages] = useState(0);

  const [localitySearchText, setLocalitySearchText] = useState("");
  const [isLocalitySearchItemsVisible, setIsLocalitySearchItemsVisible] =
    useState(false);
  const [searchedLocalities, setSearchedLocalities] = useState([]);
  const localityDropdownRef = useRef(null);

  const [apartmentSearchText, setApartmentSearchText] = useState("");
  const [isApartmentSearchItemsVisible, setIsApartmentSearchItemsVisible] =
    useState(false);
  const [searchedApartments, setSearchedApartments] = useState([]);
  const apartmentDropdownRef = useRef(null);

  // Fetch cities
  const fetchCities = async () => {
    try {
      const res = await HomeService.getCities();
      console.log("HYT31", res.data);

      if (res?.data) {
        setCities(res.data);
        if (userCity) {
          setCities([res.data.find((item) => item._id === userCity)]);
        } else {
          setCities(res.data);
        }
      }
    } catch (error) {
      console.error("Error fetching cities:", error);
    }
  };

  const addNewRow = () => {
    selectedCity && selectedPropertyType
      ? childRef.current.handleInsertFirst()
      : toast.error("Choose City and Property Type");
  };

  const saveAllRows = () => {
    selectedCity && selectedPropertyType
      ? childRef.current.saveAll()
      : toast.error("Choose City and Property Type");
  };

  //////////////////////////////////////////////////////////////////

  const [uploadingBulk, setUploadingBulk] = useState(false);
  const fileInputRef = useRef(null); // Reference for file input

  // Trigger file input when button is clicked
  const handleButtonClick = () => {
    if (!selectedCity || !selectedPropertyType || !selectedPropertyFor)
      return toast.error("Choose Property For and Property Type and City");
    fileInputRef.current.click();
  };

  const handleFileUpload = async (e) => {
    if (!selectedCity || !selectedPropertyType || !selectedPropertyFor)
      return toast.error("Choose Property For and Property Type and City");
    setUploadingBulk(true);
    const file = e.target.files[0];
    const data = new FormData();
    data.append("property", file);
    data.append("city", selectedCity);
    data.append("propertyType", selectedPropertyType);
    data.append("propertyFor", selectedPropertyFor);
    console.log("AWE77", data);
    // return

    try {
      const res = await HttpClientXml.fileUplode(
        "insert-csv-property",
        "POST",
        data,
      );
      console.log("YTR168", res);

      if (res?.status) {
        toast.success(res.message);
        setUploadingBulk(false);
        fetchLocalities();
        childRef.current.refreshLocalities(selectedCity);
        fetchProperties();
      }
    } catch (error) {
      toast.error(`Upload Failed.`);
      console.error(`Error uploading:`, error);
    }
  };

  const bulkUpload = () => {
    // selectedCity && selectedPropertyType && selectedPropertyFor ? handleFileUpload() : toast.error("Choose Property For and Property Type and City")
  };

  // /////////////////////////////////////////////////

  const deleteAllNewEntry = () => {
    childRef.current.handleDeleteAllNewEntry(
      "$",
      selectedCity,
      selectedPropertyType,
    );
  };

  // Fetch property types
  const fetchPropertyTypes = async () => {
    try {
      const res = await HomeService.getPropertyTypes();
      if (res?.data) {
        setPropertyTypes(res.data);
      }
    } catch (error) {
      console.error("Error fetching property types:", error);
    }
  };

  // Fetch properties
  const fetchProperties = async (pageNumber) => {
    // if (!selectedPropertyFor) return toast.error("Choose Property for")
    if (!selectedPropertyType) return toast.error("Choose Property type");
    if (!selectedCity) return toast.error("Choose City");

    console.log("YTR135", selectedPropertyStatus);

    setLoading(true);
    const srchData = {
      city: selectedCity,
      propertytype: selectedPropertyType,
      ...(selectedLocality && { locality: selectedLocality }),
      ...(selectedPropertyFor && { propertyFor: selectedPropertyFor }),
      ...(selectedPropertyStatus && {
        status: selectedPropertyStatus === "active" ? "true" : "false",
      }),
      ...(selectedApartment && { aptName: selectedApartment }),
      page: pageNumber || currentPage,
      limit: itemsPerPage,
    };

    console.log("YT131", srchData);

    try {
      // const res = await HomeService.getPropertiesWorksheet();
      const res = await HomeService.getFilteredProperties(srchData);
      console.log("filtered properties", res);
      if (res?.data) {
        console.log("YRW128", res?.data, selectedPropertyStatus);
        setTotalPages(Math.ceil(res?.total / itemsPerPage));

        let filteredData = res?.data.sort((a, b) => a.order - b.order);
        // if (selectedCity) {
        //     filteredData = res.data.filter((item) => item?.city?._id === selectedCity)
        // }
        // if (selectedPropertyType) {
        //     filteredData = (filteredData.filter((item) => item?.propertytype?._id === selectedPropertyType))
        // }
        /////////////////////////////////////////////

        // if (selectedCity && selectedPropertyType) {
        //     filteredData = res.data.filter((item) => item?.city?._id === selectedCity && item?.propertytype?._id === selectedPropertyType)
        // }
        // if (selectedLocality) {
        //     filteredData = filteredData.filter((item) => item?.locality?._id === selectedLocality)
        // }
        // if (selectedPropertyFor) {
        //     filteredData = filteredData.filter((item) => item?.propertyFor?.toLowerCase()?.includes(selectedPropertyFor.toLowerCase()))
        // }
        // if (selectedPropertyStatus) {
        //     const status = selectedPropertyStatus === "active" ? true : false
        //     filteredData = filteredData.filter((item) => item?.status === status)
        // }
        // if (selectedApartment) {
        //     filteredData = filteredData.filter((item) => item?.aptName?.toLowerCase()?.includes(selectedApartment.toLowerCase()))
        // }

        ///////////////////////////////////////////////////////////////
        // if(selectedAddress){
        //     filteredData = filteredData.filter((item) => item?.address?.toLowerCase()?.includes(selectedAddress.toLowerCase()))
        // }
        console.log("CFR97", filteredData);

        // filteredData.map((item, index) => {
        //     cityId = item?.city._id
        //     localityId = item?.locality._id
        //     let newFormValues = [...apartmentOptions];

        //     propertyApartmentList = allApartments.filter((item) => item?.city._id === cityId && item?.locality._id === localityId)

        //     newFormValues[index] = propertyApartmentList;
        //     setApartmentOptions(newFormValues);

        //     console.log("VFD198", newFormValues);
        // })

        const updatedApartmentOptions = filteredData.map((item) => {
          const cityId = item?.city._id;
          const localityId = item?.locality?._id;
          let formattedList = [];

          console.log("CFR221", allApartments);

          const propertyApartmentList = allApartments.filter(
            (apt) =>
              apt?.city?._id === cityId && apt?.locality?._id === localityId,
          );

          if (propertyApartmentList.length) {
            formattedList = propertyApartmentList.map((item) => ({
              _id: item._id,
              name: item.aptName,
            }));
          }
          console.log("LKF223", propertyApartmentList, formattedList);

          return formattedList;
          // return propertyApartmentList;
        });

        setApartmentOptions(updatedApartmentOptions);
        console.log("VFD230", updatedApartmentOptions);

        // setLoading(false)
        setProperties(filteredData);
        setPropertiesForFutureUse(filteredData);
        setTotalFilteredProperty(filteredData?.length);
        setSelectedAddress("");
        // Defer until after the DOM updates
        setTimeout(() => {
          setTimeout(() => {
            setLoading(false);
          }, 3000);
        }, 0);
      }
    } catch (error) {
      console.error("Error fetching property types:", error);
    }
  };

  const getCityNameById = (id) => {
    const city = cities.find((city) => city._id === id);
    return city?.name;
  };

  const getPropertyTypeNameById = (id) => {
    const propertyType = propertyTypes.find((type) => type._id === id);
    return propertyType?.propertyType;
  };

  // Fetch localities
  const fetchLocalities = async () => {
    try {
      const res = await HomeService.getLocalities();
      console.log("HYT71", res);

      if (res?.data) {
        setLocalities(
          res.data.filter((item) => item?.city?._id === selectedCity),
        );
      }
    } catch (error) {
      console.error("Error fetching localities:", error);
    }
  };

  // Fetch All Apartments
  const fetchAllApartments = async () => {
    try {
      const res = await HomeService.getApartment();
      console.log("HYT86", res.data);

      if (res?.data) {
        setAllApartments(res.data);
      }
    } catch (error) {
      console.error("Error fetching apartments:", error);
    }
  };

  // Fetch Apartments
  const fetchApartments = async () => {
    try {
      const res = await HomeService.getApartment();
      console.log("HYT86", res.data);

      if (res?.data) {
        setApartments(
          res.data.filter(
            (item) =>
              item?.city?._id === selectedCity &&
              item?.locality?._id === selectedLocality,
          ),
        );
      }
    } catch (error) {
      console.error("Error fetching apartments:", error);
    }
  };

  // Filter properties
  // const filterProperties = async (e) => {
  //   e.preventDefault();
  //   setLoading(true);
  //   try {
  //     const res = await HomeService.getPropertiesWorksheet();
  //     if (res?.data) {
  //       let filteredData = [];

  //       if (selectedCity && selectedPropertyType) {
  //         filteredData = res.data.filter(
  //           (item) =>
  //             item?.city?._id === selectedCity &&
  //             item?.propertytype?._id === selectedPropertyType,
  //         );
  //       }
  //       // if (selectedLocality) {
  //       //     filteredData = filteredData.filter((item) => item?.locality?._id === selectedLocality)
  //       // }
  //       // if(selectedApartment){
  //       //     filteredData = filteredData.filter((item) => item?.aptName?.toLowerCase()?.includes(selectedApartment.toLowerCase()))
  //       // }
  //       if (selectedAddress) {
  //         filteredData = filteredData.filter((item) =>
  //           item?.address
  //             ?.toLowerCase()
  //             ?.includes(selectedAddress.toLowerCase()),
  //         );
  //       }
  //       console.log("CFR173", res.data);
  //       // setLoading(false)
  //       setProperties(filteredData);
  //       // Defer until after the DOM updates
  //       setTimeout(() => {
  //         setTimeout(() => {
  //           setLoading(false);
  //         }, 3000);
  //       }, 0);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching property types:", error);
  //   }
  // };

  const filterProperties = async (e) => {
    e.preventDefault();
    if (!properties?.length > 0) {
      return toast.error(
        "No Property Found. Please Select some Parameter and fetch some properties!",
      );
    }
    if (!selectedAddress) {
      return toast.error("Please write something!");
    }
    const arr = properties?.filter((e, i) => {
      return e?.address
        ?.toLocaleLowerCase()
        .includes(selectedAddress?.toLocaleLowerCase());
    });

    setProperties(arr);
    setTotalFilteredProperty(arr?.length);
  };

  const availableFor = [
    {
      name: "Sale",
      value: "sale",
    },
    {
      name: "Rent",
      value: "rent",
    },
  ];

  const propertyStatus = [
    {
      name: "Active",
      value: "active",
    },
    {
      name: "Inactive",
      value: "inactive",
    },
  ];

  const [selectedPropertyFor, setSelectedPropertyFor] = useState("");
  const [selectedPropertyStatus, setSelectedPropertyStatus] = useState("");

  useEffect(() => {
    fetchCities();
    fetchPropertyTypes();
    fetchAllApartments();
  }, []);

  useEffect(() => {
    fetchLocalities();
    fetchApartments();
    selectedPropertyType && selectedCity && fetchProperties(1);
    setCurrentPage(1);
  }, [
    selectedCity,
    selectedPropertyType,
    selectedLocality,
    selectedPropertyFor,
    selectedPropertyStatus,
    selectedApartment,
    // selectedAddress,
  ]);

  const goToFirst = () => {
    // selectedCity && selectedPropertyType ? childRef.current.saveAll() : toast.error("Choose City and Property Type")
    setCurrentPage(1);
    fetchProperties(1);
  };
  const goToLast = () => {
    // selectedCity && selectedPropertyType ? childRef.current.saveAll() : toast.error("Choose City and Property Type")
    setCurrentPage(totalPages);
    fetchProperties(totalPages);
  };
  const goToPrev = () => {
    // selectedCity && selectedPropertyType ? childRef.current.saveAll() : toast.error("Choose City and Property Type")
    setCurrentPage((prev) => Math.max(prev - 1, 1));
    fetchProperties(Math.max(currentPage - 1, 1));
  };
  const goToNext = () => {
    // selectedCity && selectedPropertyType ? childRef.current.saveAll() : toast.error("Choose City and Property Type")
    setCurrentPage((prev) => Math.min(prev + 1, totalPages));
    fetchProperties(Math.min(currentPage + 1, totalPages));
  };

  // PDF and Excel Download
  function formatDate(dateString) {
    const date = new Date(dateString); // String ke Date object e convert
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  }
  // 🔹 Export PDF
  const exportPDF = () => {
    if (!properties.length) return toast.error("No data available to export");

    // const doc = new jsPDF();
    const doc = new jsPDF({
      orientation: "landscape",
      // unit: "pt", // (optional) points for better scaling
      // format: "a4", // (optional) A4 size
    });
    doc.setFontSize(16);
    doc.text("Worksheet Data", 14, 20);

    const tableColumn = [
      "Property Type",
      "Property For",
      "Locality",
      "Name",
      "Address",
      "Area",
      "BHK",
      "Floor",
      "Owner_Name",
      "Owner_Number",
    ];

    const tableRows = properties.map((row, i) => [
      row?.propertytype?.propertyType || "",
      row?.propertyFor || "",
      row?.locality?.name || "",
      row?.aptName || "",
      row?.address || "",
      row?.area || "",
      row?.bhk || "",
      row?.floor || "",
      row?.ownerName || "",
      row?.phoneNo || "",
    ]);

    autoTable(doc, {
      head: [tableColumn],
      body: tableRows,
      startY: 30,
      styles: { fontSize: 9 },
      headStyles: { fillColor: [41, 128, 185] },
    });

    doc.save("worksheet-data.pdf");
  };

  // 🔹 Export Excel
  const exportExcel = () => {
    if (!properties.length) return toast.error("No data available to export");
    console.log("properties", properties);
    const worksheetData = properties.map((row, i) => ({
      "Sl#": i + 1,
      Date: formatDate(row?.date),
      Telecaller: row?.telecaller?.name || "",
      Surveyor: row?.surveyor?.name || "",
      Feedback: row?.remarks || "",
      Available_For: row?.propertyFor || "",
      Status: row?.status || "",
      City: row?.city?.name || "",
      "Property Type": row?.propertytype?.propertyType || "",
      // "Property For": row?.propertyFor || "",
      Locality: row?.locality?.name || "",
      LocationUrl: row?.locationUrl || "",
      Apartment: row?.aptName || "",
      Address: row?.address || "",
      // Status: row?.status ? "Active" : "Inactive",
      Age: row?.age || "",
      New: row?.newEntry || "",
      Facing: row?.facing?.facing || "",
      Area: row?.area || "",
      Unit: row?.unit || "",
      Floor: row?.floor || "",
      BHK: row?.bhk || "",
      Owner: row?.ownerName || "",
      Contact_No: row?.phoneNo || "",
      Extra: row?.extra || "",
      Pricing: row?.price || "",
      Price_Unit: row?.priceUnit || "",
    }));

    const worksheet = XLSX.utils.json_to_sheet(worksheetData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Worksheet");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const data = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(data, "worksheet-data.xlsx");
  };

  useEffect(() => {
    const filteredArray = localities?.filter((item, i) => {
      return item?.name
        ?.toLowerCase()
        ?.includes(localitySearchText?.toLocaleLowerCase());
    });
    setSearchedLocalities(filteredArray);
  }, [localitySearchText]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        localityDropdownRef.current &&
        !localityDropdownRef.current.contains(event.target)
      ) {
        setIsLocalitySearchItemsVisible(false);
      }
      if (
        apartmentDropdownRef.current &&
        !apartmentDropdownRef.current.contains(event.target)
      ) {
        setIsApartmentSearchItemsVisible(false);
      }
    };

    // মাউস ডাউন ইভেন্ট লিসেনার যোগ করুন
    document.addEventListener("mousedown", handleClickOutside);

    // ক্লিনআপ ফাংশন
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const filteredArray = apartments?.filter((item, i) => {
      return item?.aptName
        ?.toLowerCase()
        ?.includes(apartmentSearchText?.toLocaleLowerCase());
    });
    setSearchedApartments(filteredArray);
  }, [apartmentSearchText]);

  return (
    <>
      <div className="main_wrap">
        <div className="row pl-4 mb-4">
          <div className="col-md-3 mt-3">
            <label>Address</label>
            <input
              type="text"
              name="address"
              className="form-control"
              value={selectedAddress}
              onChange={(e) => {
                setSelectedAddress(e.target.value);
              }}
            />
          </div>

          <div
            className="col-md-2 mt-3"
            style={{
              display: "flex",
              flexDirection: "row" /* Items are laid out in a row */,
              justifyContent:
                "flex-start" /* Align items to the left horizontally */,
              alignItems: "flex-end",
              gap: "0.5em",
            }}
          >
            <button
              style={{
                background: "rgb(133, 218, 79)",
                borderRadius: "13px",
                width: "fit-content",
                height: "fit-content",
              }}
              type="submit"
              className="btn mt-3"
              onClick={(e) => filterProperties(e)}
            >
              Filter
            </button>
            <button
              style={{
                background: "rgb(133, 218, 79)",
                borderRadius: "13px",
                width: "fit-content",
                height: "fit-content",
              }}
              type="submit"
              className="btn mt-3"
              onClick={(e) => {
                fetchProperties();
                setSelectedAddress("");
              }}
            >
              Clear
            </button>
          </div>

          <div className="col-md-7 mt-3"></div>
        </div>

        <div className="work_sheet_header">
          <div className="input_wrapper">
            {/* <div className='show_entries'>
                            <p>Show</p>
                            <select>
                                <option value={'100'}>100</option>
                            </select>
                            <p>Entries</p>
                        </div> */}
            <div className="show_entries">
              <p>Property For</p>
              <select
                value={selectedPropertyFor}
                onChange={(e) => setSelectedPropertyFor(e.target.value)}
              >
                <option value="">---All---</option>
                {availableFor.map((item, key) => (
                  <option key={key} value={item.value}>
                    {item.name}
                  </option>
                ))}
              </select>
            </div>

            <div className="show_entries">
              <p>Property Type</p>
              <select
                value={selectedPropertyType}
                onChange={(e) => setSelectedPropertyType(e.target.value)}
              >
                <option value="">---Select---</option>
                {propertyTypes.map((type) => (
                  <option key={type._id} value={type._id}>
                    {type.propertyType}
                  </option>
                ))}
              </select>
            </div>

            <div className="show_entries">
              <p>City</p>
              <select
                value={selectedCity}
                onChange={(e) => {
                  setSelectedCity(e.target.value);
                }}
              >
                <option value="">---Select---</option>
                {cities.map((city, key) => (
                  <option key={key} value={city._id}>
                    {city.name}
                  </option>
                ))}
              </select>
            </div>

            {/* <div className="show_entries">
              <p>Locality</p>
              <select
                value={selectedLocality}
                onChange={(e) => {
                  setSelectedLocality(e.target.value);
                }}
              >
                <option value="">---All---</option>
                {localities.map((item, key) => (
                  <option key={key} value={item._id}>
                    {item.name}
                  </option>
                ))}
              </select>
            </div> */}

            <div
              style={{ position: "relative" }}
              ref={localityDropdownRef}
              className="show_entries"
              // onClick={() => {
              //   if (isLocalitySearchItemsVisible) {
              //     setIsLocalitySearchItemsVisible(false);
              //   }
              // }}
            >
              <p>Locality</p>
              <input
                placeholder="Search Locality..."
                onClick={() => {
                  setIsLocalitySearchItemsVisible(true);
                }}
                value={localitySearchText}
                onChange={(e) => {
                  setLocalitySearchText(e?.target?.value);
                }}
              ></input>
              {isLocalitySearchItemsVisible && (
                <div
                  style={{
                    position: "absolute",
                    height: "200px",
                    minWidth: "75%",
                    backgroundColor: "white",
                    borderRadius: "5px",
                    top: "100%",
                    left: "25%",
                    border: "1px solid black",
                    padding: "5px 10px",
                    overflow: "auto",
                    scrollbarWidth: "none",
                    zIndex: "9999",
                  }}
                >
                  {localitySearchText
                    ? searchedLocalities.map((item, key) => (
                        <p
                          key={key}
                          style={{ marginBottom: "10px", color: "black" }}
                          className="locality-item"
                          onClick={() => {
                            setSelectedLocality(item?._id);
                            setLocalitySearchText(item?.name);
                            setIsLocalitySearchItemsVisible(false);
                          }}
                        >
                          {item.name}
                        </p>
                      ))
                    : localities.map((item, key) => (
                        <p
                          key={key}
                          style={{ marginBottom: "10px", color: "black" }}
                          className="locality-item"
                          onClick={() => {
                            setSelectedLocality(item?._id);
                            setLocalitySearchText(item?.name);
                            setIsLocalitySearchItemsVisible(false);
                          }}
                        >
                          {item.name}
                        </p>
                      ))}
                </div>
              )}
            </div>

            <div className="show_entries">
              <p>Status</p>
              <select
                value={selectedPropertyStatus}
                onChange={(e) => setSelectedPropertyStatus(e.target.value)}
              >
                <option value="">---All---</option>
                {propertyStatus.map((item, key) => (
                  <option key={key} value={item.value}>
                    {item.name}
                  </option>
                ))}
              </select>
            </div>

            {/* <div className="show_entries">
              <p>Apartment/Building</p>
             
              <select
                value={selectedApartment}
                onChange={(e) => {
                  setSelectedApartment(e.target.value);
                }}
                // style={{width:"300px"}}
              >
                <option value="">---Select---</option>
                {apartments.map((item, key) => (
                  <option key={key} value={item.aptName}>
                    {item.aptName}
                  </option>
                ))}
              </select>
            </div> */}

            <div
              style={{ position: "relative" }}
              ref={apartmentDropdownRef}
              className="show_entries"
              // onClick={() => {
              //   if (isLocalitySearchItemsVisible) {
              //     setIsLocalitySearchItemsVisible(false);
              //   }
              // }}
            >
              <p>Apartment / Building</p>
              <input
                placeholder="Search Apartments..."
                onClick={() => {
                  setIsApartmentSearchItemsVisible(true);
                }}
                value={apartmentSearchText}
                onChange={(e) => {
                  setApartmentSearchText(e?.target?.value);
                }}
              ></input>
              {isApartmentSearchItemsVisible && (
                <div
                  style={{
                    position: "absolute",
                    height: "200px",
                    minWidth: "75%",
                    backgroundColor: "white",
                    borderRadius: "5px",
                    top: "100%",
                    left: "25%",
                    border: "1px solid black",
                    padding: "5px 10px",
                    overflow: "auto",
                    scrollbarWidth: "none",
                    zIndex: "99999",
                  }}
                >
                  {apartmentSearchText ? (
                    searchedApartments?.length === 0 ? (
                      <p style={{ marginBottom: "10px", color: "black" }}>
                        No Apartment Found
                      </p>
                    ) : (
                      searchedApartments.map((item, key) => (
                        <p
                          key={key}
                          style={{ marginBottom: "10px", color: "black" }}
                          className="locality-item"
                          onClick={() => {
                            setSelectedApartment(item?.aptName);
                            setApartmentSearchText(item?.aptName);
                            setIsApartmentSearchItemsVisible(false);
                          }}
                        >
                          {item.aptName}
                        </p>
                      ))
                    )
                  ) : apartments?.length === 0 ? (
                    <p style={{ marginBottom: "10px", color: "black" }}>
                      No Apartment Found
                    </p>
                  ) : (
                    apartments.map((item, key) => (
                      <p
                        key={key}
                        style={{ marginBottom: "10px", color: "black" }}
                        className="locality-item"
                        onClick={() => {
                          setSelectedApartment(item?.aptName);
                          setApartmentSearchText(item?.aptName);
                          setIsApartmentSearchItemsVisible(false);
                        }}
                      >
                        {item.aptName}
                      </p>
                    ))
                  )}
                </div>
              )}
            </div>
          </div>
          <div
            style={{
              display: "flex",
              columnGap: "10px",
            }}
          >
            {/* <button className='new_btn' onClick={bulkUpload}>Bulk Upload</button> */}

            <input
              type="file"
              accept=".csv"
              ref={fileInputRef}
              style={{ display: "none" }}
              onChange={handleFileUpload}
            />
            <button className="new_btn" onClick={handleButtonClick}>
              {uploadingBulk ? "Uploading bulk data..." : "Upload in Bulk"}
            </button>
            <button className="new_btn" onClick={addNewRow}>
              Add New Row
            </button>
            <button className="new_btn" onClick={saveAllRows}>
              Save All
            </button>
            <button
              className="remove_btn"
              onClick={deleteAllNewEntry}
              style={{
                display:
                  localStorage?.getItem("role") === "survey" ? "none" : "",
              }}
            >
              Remove all $
            </button>
            <button
              className="new_btn"
              onClick={exportPDF}
              style={{
                display:
                  localStorage?.getItem("role") === "survey" ? "none" : "",
              }}
            >
              Export PDF ({properties?.length})
            </button>
            <button
              className="new_btn"
              onClick={exportExcel}
              style={{
                display:
                  localStorage?.getItem("role") === "survey" ? "none" : "",
              }}
            >
              Export Excel ({properties?.length})
            </button>
          </div>
          {totalFilteredProperty && (
            <div style={{ color: "white" }}>
              Total Filtered Property : {totalFilteredProperty}
            </div>
          )}
        </div>
        <div
          className="data_table_Wrapper"
          style={{
            height: "100%",
            // height: "50vh",
          }}
        >
          <WorksheetTable
            ref={childRef}
            tableData={properties}
            localityList={localities}
            pcity={selectedCity}
            ptype={selectedPropertyType}
            pfor={selectedPropertyFor}
            reload={fetchProperties}
            cityName={getCityNameById}
            propertyTypeName={getPropertyTypeNameById}
            loading={loading}
            pageno={currentPage}
            perPage={itemsPerPage}
            apartmentOptions={apartmentOptions}
          />
        </div>
        {totalPages > 0 && (
          <div className="work_sheet_header">
            <div className="input_wrapper" style={{ margin: "0 auto" }}>
              <button
                className="new_btn"
                onClick={goToFirst}
                disabled={currentPage === 1}
              >
                First
              </button>
              <button
                className="new_btn"
                onClick={goToPrev}
                disabled={currentPage === 1}
              >
                Previous
              </button>

              <span style={{ margin: "0 10px", color: "#ffffff" }}>
                Page {currentPage} of {totalPages}
              </span>

              <button
                className="new_btn"
                onClick={goToNext}
                disabled={currentPage === totalPages}
              >
                Next
              </button>
              <button
                className="new_btn"
                onClick={goToLast}
                disabled={currentPage === totalPages}
              >
                Last
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Worksheet;
